import React, { useEffect, useState } from "react";
import TopNavBar from "../../../Components/TopNavbar";
import LeftSideNav from "../../../Components/LeftSideNav";
import {
  Paper,
  TableContainer,
  TextField,
  Grid,
  Typography,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import Colors from "../../../theme/Colors";
import Strings from "../../../Config/Strings";
import Fonts from "../../../Config/Fonts";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addProductMetalDetailsAPI } from "../../../Store/Action/productMetalAction";
import { toast } from "react-toastify";
import Loader from "../../../Components/Loader";
import CustomButton from "../../../Components/CustomButton";

const AddProductMetal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    const requestData = {
      product_metal_name: data?.metalName,
    };
    setLoading(true);
    try {
      await dispatch(
        addProductMetalDetailsAPI(requestData, (isSuccess, response) => {
          setLoading(false);
          if (isSuccess?.status === true) {
            toast.success("Product Metal Added Successfully");
            navigate("/productMetal");
          } else {
            const errorMessage =
              response?.error?.message || Strings.somethingWentWrongError;
            toast.error(errorMessage);
          }
        })
      );
    } catch (error) {
      console.log("Error dispatching addProducts:", error);
      setLoading(false);
      toast.error(Strings.somethingWentWrongError);
    }
  };

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/", text: "Masters" },
      { key: "2", href: "/productMetal", text: "Product Metal" },
      { key: "3", href: "/AddProductMetal", text: "Add Product Metal" },
    ]);
  }, []);

  return (
    <div style={mainContainer}>
      <LeftSideNav />

      <div style={leftNavContainer}>
        <div style={topBar}>
          <TopNavBar />

          <div style={pageTitle}>
            <h2>Product Metal</h2>
          </div>

          <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
        </div>

        <TableContainer component={Paper} style={tableContainer}>
          <p style={mainHeadingStyle}>Product Metal</p>

          <hr />

          <form onSubmit={handleSubmit(onSubmit)} style={formStyle}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Metal Name</Typography>
                <Controller
                  name="metalName"
                  control={control}
                  defaultValue=""
                  rules={{ required: Strings.productNameRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter metal name"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.metalName}
                      helperText={
                        errors?.metalName ? errors?.metalName.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle, // Set background color
                      }}
                    />
                  )}
                />
              </Grid>

              <CustomButton handleSubmit={handleSubmit} label={Strings.Save} />
            </Grid>
          </form>
        </TableContainer>
      </div>

      <Loader loading={loading} />
    </div>
  );
};

const mainContainer = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100vh",
  width: "100vw",
  overflowX: "hidden",
  overflowY: "hidden",
};

const leftNavContainer = {
  display: "grid",
  gridTemplateRows: "15% 80%",
  backgroundColor: "#F0F5FF",
};

const topBar = {
  backgroundColor: "white",
  height: "7vh",
  width: "100%",
};

const pageTitle = {
  marginLeft: "30px",
  justifyContent: "flex-start",
  display: "flex",
};

const tableContainer = {
  width: "70vw",
  border: "1px solid #ccc",
  borderRadius: "15px",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  marginTop: "40px",
  paddingLeft: "20px",
  paddingRight: "20px",
  marginLeft: "30px",
};

const formStyle = {
  padding: "10px",
};

const mainHeadingStyle = {
  fontSize: 16,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.black,
  display: "flex",
  marginTop: "20px",
  marginBottom: '10px'
};

const labelInfoStyle = {
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.black,
  display: "flex",
  marginBottom: "5px",
};

const inputTextStyle = {
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.darkGray,
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  backgroundColor: Colors.lightBlue,
};

export default AddProductMetal;
